import { se } from "../../../../date-fns/locale/se.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    se
  }
};